const flattenArray = (arr: any[]): string[] => {
	return arr.map((item) => item.labelSingular);
};
export default flattenArray;
